module.exports = __webpack_public_path__ + "fonts/century_00f1440b3cba6e07fc07639f3121ff8e.ttf";